import script from "./ProductImageSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductImageSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductImageSkeleton.vue?vue&type=style&index=0&id=46b3d8d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b3d8d2"]])

export default __exports__